import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ContextProvider from './Context/ContextProvider';
import AboutTwo from './Pages/About/AboutTwo';
import ContactTwo from './Pages/Contact/ContactTwo';
import ConstitutionPage from './Pages/Extra/Constitution';
import HomeTwo from './Pages/Home/HomeTwo';
import MusicPage from './Pages/Music/MusicPage';
import PortfiloTwo from './Pages/Portfilo/PortfiloTwo';
import ResumeTwo from './Pages/Resume/ResumeTwo';
import NotFound from './Share/NotFound';
import CatanBellCurve from './Pages/Catan/CatanBellCurve';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1200 });
    AOS.refresh();
  }, []);
  return (
      <ContextProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeTwo />}>
              <Route index element={<AboutTwo />} />
              <Route path="about" element={<AboutTwo />} />
              <Route path="resume" element={<ResumeTwo />} />
              <Route path="contact" element={<ContactTwo />} />
              <Route path="music" element={<MusicPage />} />
              <Route path="works" element={<PortfiloTwo />} />
              <Route path="slides/">
                <Route path="accessu" element={<AboutTwo downloadUrl="/slides/AccessU_2025.pptx" />} />
              </Route>
            </Route>
           
            <Route path="/extra/">
              <Route path="constitution" element={<ConstitutionPage />} />
              <Route path="catan" element={<CatanBellCurve />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </ContextProvider>
  );
}

export default App;
